import React from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { useNavigate } from 'react-router'
import Popup from '@Components/Popups/Popup'

interface SelfPublisherSongwriterPopupProps {
    onClose(): void
}

const SelfPublisherSongwriterPopup = (props: SelfPublisherSongwriterPopupProps) => {
    const { onClose } = props
    const navigate = useNavigate()

    const startRegistration = async () => {
        onClose()
        navigate(Navigation.registrationRightsholder.form(), { state: { memberType: 'Songwriter' } })
    }

    return (
        <Popup onClose={() => onClose()} showClose className="self-publisher-songwriter">
            <div>
                <h3>You selected: Self-Administered or Partially Self-Administered</h3>
                <p>
                    Since you are self-administered or partially self-administered, the Member Hub ensures that your
                    songs are properly registered and that you have access to tools for managing your own catalog and
                    royalties. Let’s continue and set up your Member Hub details first.
                </p>
            </div>
            <div className="footer-block">
                <Button mainColor type="secondary" onClick={() => onClose()}>
                    Back
                </Button>
                <Button mainColor type="primary" onClick={() => startRegistration()}>
                    Next
                </Button>
            </div>
        </Popup>
    )
}

export default SelfPublisherSongwriterPopup
